<template>

  <div>
    <template v-if="loading">
      <div class="text-muted small py-1">
        <i class="fa-solid fa-circle-notch fa-spin mr-1"></i>{{ $t('Searching candidates') }}
      </div>
    </template>
    <template v-else>
      <div
        v-if="!candidates.length"
        class="text-muted small py-1">
        {{ $t('No candidate found with this contact') }}
      </div>
      <div v-else class="contact-candidate-list">
        <div
          v-for="item in candidates"
          :key="item._id"
          class="contact-candidate-row d-flex align-items-center py-1">
          <a
            href="javascript:void(0)"
            class="d-flex align-items-center flex-grow-1 text-body"
            @click="openCandidate(item)">
            <Avatar
              class="flex-shrink-0 mr-2"
              :src="photo(item)"
              :name="item.name"
              size="32px"
              radius="16px" />
            <span class="text-truncate">{{ item.name || $t('No name') }}</span>
          </a>
          <button
            type="button"
            class="btn btn-sm btn-outline-secondary flex-shrink-0 ml-2"
            @click="associate(item._id)">{{ $t('Associate') }}</button>
        </div>
      </div>
    </template>
  </div>

</template>

<script>
import config from '@/config'
import Avatar from '@/components/Parts/Avatar'

export default {
  name: 'ContactCandidateFieldList',
  components: {
    Avatar
  },
  props: {
    conversation: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      candidates: []
    }
  },
  computed: {
    /*
    contactQuery
    the search made on the candidates: the same number is written in many
    formats (+55 11 99491-1337, (11) 99491-1337, 11994911337), so the query
    covers the whole number, the number without the country code, the local
    number and the local number split before the last 4 digits (which is what
    matches the formatted ones)
    */
    contactQuery () {
      const address = (this.conversation.contact_address || '').trim()

      if (!address) {
        return null
      }

      if (this.conversation.type === 'email') {
        return '"' + address + '"'
      }

      const digits = address.replace(/[^0-9]/g, '')

      if (digits.length < 8) {
        return null
      }

      const national = digits.length > 11 ? digits.slice(-11) : digits
      const local = national.length > 9 ? national.slice(-9) : national
      const terms = [digits, national, local, local.slice(0, -4) + ' ' + local.slice(-4)]

      return terms
      .filter((term, index) => { return terms.indexOf(term) === index })
      .map((term) => { return '"' + term + '"' })
      .join(' OR ')
    }
  },
  /*
  the parent renders this list with the conversation id as key, so a new
  conversation is a new component: the search belongs to the creation
  */
  created () {
    this.loadCandidates()
  },
  methods: {
    /*
    photo
    the candidate default picture is a placeholder image: dropping it lets the
    Avatar fall back to the initials
    */
    photo (candidate) {
      const url = candidate && candidate.photo_media_url
      return url && !url.includes(config.default_image_url.candidate) ? url : null
    },
    /*
    loadCandidates
    searches the candidates that have the contact address of the conversation
    */
    loadCandidates () {
      if (!this.contactQuery) {
        this.candidates = []
        return
      }
      this.loading = true

      this.$store
      .dispatch('getCandidates', {
        identity: '~' + this.contactQuery,
        sort: '-score',
        limit: 5,
        abortid: 'conversation-candidate-suggestions'
      })
      .then((result) => {
        this.candidates = result.docs || []
      })
      .catch(() => {
        this.candidates = []
      })
      .finally(() => {
        this.loading = false
      })
    },
    /*
    openCandidate
    */
    openCandidate (candidate) {
      this.$openCandidateModal(candidate._id)
    },
    associate (candidateId) {
      this.$emit('associate', candidateId)
    }
  }
}
</script>

<style scoped>
/* let the name shrink so text-truncate works inside the flex row */
.contact-candidate-row a,
.contact-candidate-row .text-truncate {
  min-width: 0;
}

.contact-candidate-row a:hover {
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Messaging/contact/ContactCandidateFieldList.vue